// components/FeedbackCard.jsx
import React, { useState } from 'react';
import { Typography, Button, TextField, Card } from '@mui/material';

const FeedbackCard = () => {
  const [feedback, setFeedback] = useState('');

  const handleSubmit = () => {
    alert('Feedback submitted!');
  };

  return (
    <Card style={{ padding: '20px', margin: '10px 0' }}>
      <Typography variant="h6">Feedback</Typography>
      <TextField
        fullWidth
        multiline
        rows={4}
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
        placeholder="Enter your feedback"
      />
      <Button variant="contained" onClick={handleSubmit} style={{ marginTop: '10px' }}>
        Submit Feedback
      </Button>
    </Card>
  );
};

export default FeedbackCard;